<div class="app-edit-charger-connectors-dialog">
  <div class="header">
    <h3>Edit Connectors</h3>
    <button mat-icon-button class="close-button" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <div class="content">
    <div class="error-message" *ngIf="state() === 'error'">
      <mat-icon>error</mat-icon>
      Something went wrong. Please try again later.
    </div>

    <div class="success-message" *ngIf="state() === 'success'">
      <mat-icon>check_circle</mat-icon>
      Connectors updated successfully.
    </div>

    <div class="chargers-list">
      @for (charger of getVisibleChargers(); track charger; let chargerIdx = $index) {
        <div class="charger-card">
          <div class="charger-header">
            <mat-form-field appearance="outline" class="charger-name-field">
              <mat-label>Charger Name</mat-label>
              <input matInput [(ngModel)]="charger.name" placeholder="e.g., Charger 1">
            </mat-form-field>
            <button mat-icon-button class="delete-charger-btn" (click)="removeCharger(chargerIdx)" type="button">
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          <div class="connectors-section">
            <div class="connectors-header">
              <span class="connectors-title">Connectors</span>
              <button mat-stroked-button type="button" (click)="addConnector(chargerIdx)" class="add-connector-btn">
                <mat-icon>add</mat-icon>
                Add Connector
              </button>
            </div>

            <div class="connectors-list">
              @for (connector of getVisibleConnectors(charger); track connector; let connectorIdx = $index) {
                <div class="connector-card">
                  <div class="connector-card-header">
                    <div class="connector-icon">
                      <img [src]="getConnectorIcon(connector.connectorTypeId)" alt="Connector icon">
                    </div>
                    <mat-form-field appearance="outline" class="connector-type-field">
                      <mat-label>Type</mat-label>
                      <mat-select [(ngModel)]="connector.connectorTypeId">
                        <mat-option *ngFor="let type of connectorTypes" [value]="type.connectorTypeId">
                          {{ type.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <button mat-icon-button class="delete-connector-btn" (click)="removeConnector(chargerIdx, connectorIdx)" type="button">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>

                  <div class="connector-specs">
                    <mat-form-field appearance="outline" class="spec-field">
                      <mat-label>Power (kW)</mat-label>
                      <input matInput type="number" [(ngModel)]="connector.chargeKwh" min="0">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="spec-field">
                      <mat-label>Volts</mat-label>
                      <input matInput type="number" [(ngModel)]="connector.chargeVolts" min="0">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="spec-field">
                      <mat-label>Amps</mat-label>
                      <input matInput type="number" [(ngModel)]="connector.chargeAmps" min="0">
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="spec-field">
                      <mat-label>Power Type</mat-label>
                      <mat-select [(ngModel)]="connector.powerType">
                        <mat-option *ngFor="let type of powerTypes" [value]="type">
                          {{ type }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              }

              <div class="no-connectors" *ngIf="getVisibleConnectors(charger).length === 0">
                <p>No connectors added yet</p>
              </div>
            </div>
          </div>
        </div>
      }

      <div class="no-chargers" *ngIf="getVisibleChargers().length === 0">
        <mat-icon>ev_station</mat-icon>
        <p>No chargers configured</p>
        <span>Add a charger to get started</span>
      </div>
    </div>

    <button mat-stroked-button type="button" (click)="addCharger()" class="add-charger-btn">
      <mat-icon>add</mat-icon>
      Add Charger
    </button>
  </div>

  <mat-divider></mat-divider>

  <div class="actions">
    <button mat-button type="button" (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" type="button" (click)="submitForm()" [disabled]="state() === 'loading'">
      <mat-spinner *ngIf="state() === 'loading'" diameter="20"></mat-spinner>
      Save Changes
    </button>
  </div>
</div>
